import React from 'react';
import {BrowserRouter as Router, Route} from 'react-router-dom';

import Redirect from './containers/Redirect'
import Success from './containers/Success'
import Failure from './containers/Failure'
import Download from './containers/Download'
import Invoice from './containers/Invoice'
import Transaction from './containers/Transaction'

export default () => {
    return (
        <Router>
            <Route exact path="/" component={Redirect} />
            <Route path="/success" component={Success}/>
            <Route path="/failure" component={Failure}/>
            <Route path="/download" component={Download} />
            <Route path="/invoice/:invoiceId/key/:downloadKey" component={Invoice} />
            <Route path="/payment/:transactionId/key/:transactionKey" component={Transaction} />
        </Router>
    );
};
